import React from 'react';

import { cn } from 'src/component/ds/utils';
import { SidebarMenuBadge } from 'src/component/ds/ui/sidebar';
import { navCountPillClassName } from './navRow';

export default function DeviceNavCount ({ count, className }: { count: number; className?: string }) {
  return (
    <SidebarMenuBadge
      className={cn(
        navCountPillClassName,
        'peer-data-[size=default]/menu-button:ds-top-2',
        'peer-hover/menu-button:ds-text-sidebar-foreground',
        'peer-data-[active=true]/menu-button:ds-bg-sidebar-accent-tint',
        className
      )}
    >
      {count}
    </SidebarMenuBadge>
  );
}
